import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import {
  DeliveryOption,
  DeliveryOptions,
} from "./DeliveryOptions/DeliveryOptions";
import { ProductDeliveryReturns } from "./ProductDeliveryReturns/ProductDeliveryReturns";
import { ExtendedReturnsPolicy } from "./ExtendedReturnsPolicy/ExtendedReturnsPolicy";

export const PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME =
  "product-delivery-options";

export type Props = {
  deliveryOptions: DeliveryOption[];
  skuId: string;
  isAvailableToOrderOrPreorder: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
  isInExtendedReturnsWindow: boolean;
  isRetired: boolean;
  isInStoreOnly: boolean;
  open?: boolean;
};

export function ProductDeliveryOptionsAccordionUI({
  deliveryOptions,
  skuId,
  isAvailableToOrderOrPreorder,
  stockApiBaseUrl,
  stockApiKey,
  isInExtendedReturnsWindow,
  isInStoreOnly,
  isRetired,
  open,
}: Props) {
  if (isRetired) return null;
  if (isInStoreOnly) return null;

  return (
    <Accordion
      id="accordion-delivery"
      data-testid="accordion:delivery"
      label="Delivery & returns"
      animated={true}
      instanceName={PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME}
      responsive
      open={open}
    >
      {deliveryOptions.length > 0 && (
        <DeliveryOptions
          skuId={skuId}
          isAvailableToOrderOrPreorder={isAvailableToOrderOrPreorder}
          deliveryOptions={deliveryOptions}
          stockApiBaseUrl={stockApiBaseUrl}
          stockApiKey={stockApiKey}
        />
      )}
      <ProductDeliveryReturns />
      {isInExtendedReturnsWindow && <ExtendedReturnsPolicy />}
    </Accordion>
  );
}
